import { Modal } from './accessibility.jsx';

function FeedbackDialog({ message, defaultValue, options, onDone }) {
  const he = (options.lang || localStorage.getItem('pcm_lang')) === 'he';
  const input = React.useRef(null);
  const descriptionId = React.useId();
  const prompt = defaultValue !== undefined;
  const title = options.title || (prompt
    ? (he ? 'הזנת פרטים' : 'Enter details')
    : (he ? 'אישור פעולה' : 'Confirm action'));
  React.useEffect(() => { if (prompt) input.current?.select(); }, []);
  return <Modal label={title} descriptionId={descriptionId} dir={he ? 'rtl' : 'ltr'}
                className="dlg card feedback-dialog" onClose={() => onDone(prompt ? null : false)}>
    <form className="feedback-form" dir={he ? 'rtl' : 'ltr'} onSubmit={event => {
      event.preventDefault();
      onDone(prompt ? input.current.value : true);
    }}>
      <h2 className="feedback-title">{title}</h2>
      <p className="feedback-message" id={descriptionId} dir="auto">{message}</p>
      {prompt && <input ref={input} className="set-input feedback-input" defaultValue={defaultValue}
                        aria-label={he ? 'ערך חדש' : 'New value'} dir="auto"/>}
      <div className="dlg-actions feedback-actions">
        <button type="button" className="btn" onClick={() => onDone(prompt ? null : false)}>
          {he ? 'ביטול' : 'Cancel'}
        </button>
        <button type="submit" className={`btn primary${options.danger ? ' danger' : ''}`}>
          {options.confirmLabel || (he ? 'המשך' : 'Continue')}
        </button>
      </div>
    </form>
  </Modal>;
}

function ask(message, defaultValue, options) {
  return new Promise(resolve => {
    const host = document.createElement('div');
    host.dataset.feedbackRoot = '';
    document.body.appendChild(host);
    const root = ReactDOM.createRoot(host);
    let settled = false;
    const finish = value => {
      if (settled) return;
      settled = true;
      root.unmount();
      host.remove();
      resolve(value);
    };
    root.render(<FeedbackDialog message={message} defaultValue={defaultValue} options={options} onDone={finish}/>);
  });
}

export function confirmAction(message, options = {}) {
  return ask(message, undefined, options);
}

export function promptAction(message, defaultValue = '', options = {}) {
  return ask(message, defaultValue, options);
}
